import React from "react";
import { Link } from "react-router-dom";

const SideMenu = ({ profilePic }) => {
  return (
    <>
      <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
        <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
          <a
            href="/"
            className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none"
          >
            <span className="fs-5 d-none d-sm-inline">Menu</span>
          </a>
          <img
            class="avatarr"
            src={
              profilePic
                ? profilePic
                : "https://ekanatechnologies.in-old/wp-content/plugins/townhub-add-ons/assets/images/avatar.jpg"
            }
            data-was-processed="true"
          />
          <ul
            className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
            id="menu"
          >
            <li className="nav-item">
              <Link
                to="/dashboard"
                className="nav-link align-middle px-0"
              >
                <i className="fs-4 bi-house"></i>{" "}
                <span className="ms-1 d-none d-sm-inline">Dashboard</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to="/edit-profile"
                className="nav-link align-middle px-0"
              >
                <i className="fs-4 bi-house"></i>{" "}
                <span className="ms-1 d-none d-sm-inline">Edit Profile</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/change-password"
                className="nav-link align-middle px-0"
              >
                <i className="fs-4 bi-house"></i>{" "}
                <span className="ms-1 d-none d-sm-inline">Change Password</span>
              </Link>
            </li>

            <li>
              <Link
                to="/my-listings"
                className="nav-link px-0 align-middle"
              >
                <i className="fs-4 bi-table"></i>{" "}
                <span className="ms-1 d-none d-sm-inline">My Listing</span>
              </Link>
            </li>

            <li>
              <Link
                to="/add-listing"
                className="nav-link px-0 align-middle"
              >
                <i className="fs-4 bi-people"></i>{" "}
                <span className="ms-1 d-none d-sm-inline">Add Listing</span>{" "}
              </Link>
            </li>
          </ul>
          <hr />
        </div>
      </div>
    </>
  );
};

export default SideMenu;
